<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/require-v-for-key -->
<template>
  <div class="p-5 flex flex-col">
    <p class="font-semibold text-3xl">
      List Vessel Line Up
    </p>
    <vs-row
      vs-w="12"
      class="mt-5 filter-container"
    >
      <vs-col vs-w="1">
        <p class="font-semibold">
          Filter
        </p>
      </vs-col>
      <vs-col vs-w="1.5">
        <date-picker
          class="px-2"
          type="month"
          format="MMM-YYYY"
          value-type="format"
          placeholder="Expected Month"
          v-model="filter.expected_month"
        />
      </vs-col>
      <vs-col vs-w="2">
        <select-with-search
          hide-search
          class="px-2"
          :options="options.vessel"
          placeholder="Select Vessel"
          v-model="filter.vessel"
        />
      </vs-col>
      <vs-col vs-w="2">
        <select-with-search
          hide-search
          class="px-2"
          :options="options.company"
          placeholder="Select Company"
          v-model="filter.company"
        />
      </vs-col>
      <vs-col vs-w="1.5">
        <select-with-search
          hide-search
          class="px-2"
          :options="polOptions"
          placeholder="Select L.Port"
          v-model="filter.l_port"
        />
      </vs-col>
      <vs-col vs-w="2">
        <select-with-search
          hide-search
          class="px-2"
          :options="statusOptions"
          placeholder="Select Status"
          v-model="filter.status"
        />
      </vs-col>
      <vs-col vs-w=".5" />
      <vs-col
        vs-w="1.5"
        class="flex flex-col justify-center"
      >
        <vs-button
          type="border"
          color="primary"
          class="px-2 w-40 self-end font-semibold"
          @click="resetFilter"
        >
          Reset
        </vs-button>
      </vs-col>
    </vs-row>
    <div class="p-5 flex flex-col mt-5 bg-white rounded-md">
      <div class="flex">
        <vs-button
          type="border"
          class="button font-semibold vs-con-loading__container"
          id="sync-loading"
          color="secondary"
          @click="onHandleVLUSync"
          :disabled="isLoadingSync"
        >
          <div class="-mt-5 flex items-center">
            <p>Last Sync: {{ validateAndFormatDate(lastSyncTimeData, 'DD-MMM-YYYY HH:mm') }}</p>
            <span class="ml-3 material-icons-outlined">
              change_circle
            </span>
          </div>
        </vs-button>
      </div>
      <table-top
        ref="tabletop"
        is-search-has-border
        :page-size-start="false"
        class="mt-6"
        @fetch="fetchVesselLineUpList()"
      >
        <template #start>
          <vs-button
            v-show="false"
            class="button shadow-secondary"
            color="secondary"
            @click="$router.push({ name: 'VesselLineUpCreate' })"
          >
            Add VLU
          </vs-button>
          <div
            v-show="false"
            class="mx-4 divider"
          />
          <vs-button
            v-if="isUserCanAccessMenu('Tentative Barge Schedule', 'add')"
            class="button w-auto font-semibold vs-con-loading__container whitespace-no-wrap"
            id="flf-loading"
            color="#836ADA"
            @click="sendToFLF()"
            :disabled="isLoadingFLF"
          >
            Send to FLF/FC
          </vs-button>
          <vs-button
            class="button font-semibold ml-5"
            color="secondary"
            @click="downloadVLU()"
            :disabled="isDownload"
          >
            Export VLU
          </vs-button>
          <vs-button
            class="button font-semibold ml-5"
            color="secondary"
            @click="downloadTBS()"
            :disabled="isDownload || !filter.expected_month"
          >
            Export TBS
          </vs-button>
        </template>
      </table-top>
      <data-table
        class="mt-6"
        :table-header="tableHeaders"
        :table-data="tableData"
        :sort-by="filter.sort_by"
        :sort-dir="filter.sort_dir"
        @sort="sort"
        :loading="isBusy"
        :frozen-columns="6"
        :grouped-headers="groupHeader"
        :expanded-rows-list="expandedRowsList"
        :is-expanded-row-keep-same-header-col="true"
      >
        <template #no="{ index }">
          <div class="flex flex-row w-min">
            {{ (currentPage - 1) * pageSize + index + 1 }}
          </div>
        </template>
        <template #action="{ row }">
          <div class="flex flex-row gap-x-3">
            <template v-if="row.isEditing">
              <div
                class="mx-1 self-center flex items-center justify-center icon-transparent-bg action-submit"
                @click="onHandleSubmit(row)"
              >
                <img :src="require('@/assets/shipo-icon-check-circle.svg')">
              </div>
              <div
                class="mx-1 self-center flex items-center justify-center icon-transparent-bg action-cancel delete"
                @click="onHandleCancel(row)"
              >
                <img :src="require('@/assets/shipo-icon-close-circle.svg')">
              </div>
            </template>
            <template v-else>
              <div
                class="flex items-center justify-center cursor-pointer icon-transparent-bg"
                @click="toggleRow(row)"
              >
                <img
                  :src="
                    require(
                      expandedRowsList.includes(row.id) 
                        ? '@/assets/shipo-icon-arrow-up.svg' : '@/assets/shipo-icon-arrow-down.svg')"
                >
              </div>
              <div
                v-if="isUserCanAccessMenu(permission.name, 'edit') && row.status.toLowerCase() !== 'completed'"
                class="flex items-center justify-center icon-transparent-bg"
                @click="onHandleEdit(row)"
              >
                <img :src="require('@/assets/shipo-icon-edit.svg')">
              </div>
              <vs-button
                v-if="isUserCanAccessMenu(permission.name, 'add')"
                color="secondary"
                class="action-button"
                @click="$router.push({ name: 'TentativeBargeSchedule', params: { id: row.id } })"
              >
                <span class="font-semibold">TBS</span>
              </vs-button>
            </template>
          </div>
        </template>
        <template #name_of_vessel="{ row }">
          <div v-if="row.isEditing">
            <vs-input
              :danger="!!!row.editForm.name_of_vessel"
              :danger-text="'* Required'"
              v-model="row.editForm.name_of_vessel"
              placeholder="Enter vessel name"
            />
          </div>
          <div v-else>
            {{ row.name_of_vessel || '-' }}
          </div>
        </template>
        <template #l_port="{ row }">
          <div v-if="row.isEditing">
            <select-with-search
              v-model="row.editForm.l_port"
              placeholder="Select POL"
              class="px-2"
              :options="getPolOptions(row)"
              :danger="!!!row.editForm.l_port"
            />
          </div>
          <div v-else>
            {{ row.l_port || '-' }}
          </div>
        </template>
        <template #lay="{ row }">
          <div v-if="row.isEditing">
            <date-picker
              style="width: 150px;"
              type="date"
              format="DD-MMM-YYYY"
              v-model="row.editForm.lay"
              :is-valid="!!row.editForm.lay"
            />
          </div>
          <div v-else>
            {{ validateAndFormatDate(row.lay, 'DD-MMM-YYYY') }}
          </div>
        </template>
        <template #can="{ row }">
          <div v-if="row.isEditing">
            <date-picker
              style="width: 150px;"
              type="date"
              format="DD-MMM-YYYY"
              v-model="row.editForm.can"
              :is-valid="!!row.editForm.can"
            />
          </div>
          <div v-else>
            {{ validateAndFormatDate(row.can, 'DD-MMM-YYYY') }}
          </div>
        </template>
        <template #end_user="{ row }">
          <div class="flex flex-row w-full">
            <div v-if="row.isEditing">
              <vs-input
                :danger="!!!row.editForm.end_user"
                :danger-text="'* Required'"
                v-model="row.editForm.end_user"
                placeholder="Enter end user"
                disabled
              />
            </div>
            <div
              v-else
              class="flex flex-row items-center self-center"
            >
              {{ row.end_user }}
              <div
                v-show="isUserCanAccessMenu(permission.name, 'add')"
                class="button-l-plan ml-2"
                @click="$router.push({ name: 'LoadingPlanCreate', params: { id: row.id } })"
              >
                <div>
                  <img
                    class="min-w-5"
                    :src="require('@/assets/shipo-icon-upload.svg')"
                  >
                </div>
                <span>Upload L.Plan</span>
              </div>
              <div
                class="button-l-plan mx-2"
                :class="{
                  'disabled filter-grey-img': !row.has_loading_plan
                }"
                @click="row.has_loading_plan
                  ? $router.push({ name: 'LoadingPlanDetail', params: { id: row.id, endUser: row.end_user } })
                  : null
                "
              >
                <div>
                  <img
                    class="min-w-8"
                    :src="require('@/assets/shipo-icon-see.svg')"
                  >
                </div>
                <span>View L.Plan</span>
              </div>
            </div>
          </div>
        </template>
        <!-- Remove from table on 24/04/2025 -->
        <template #generated_blu="{ row }">
          <div
            :class="{
              'bg-green-200 text-green-700 border-green-400':
                row.generated_blu.includes('BLU generated'),
              'bg-red-200 text-red-700 border-red-400':
                row.generated_blu.includes('not generated') ||
                row.generated_blu.includes('not uploaded')
            }"
            class="button-l-plan"
            @click="$router.push({ name: 'BargeLineUpList', query: { filter: { name_of_vessel: row.name_of_vessel} } })"
          >
            <span>{{ row.generated_blu }}</span>
          </div>
        </template>
        <template #status="{ row }">
          <div v-if="row.isEditing">
            <select-with-search
              v-model="row.editForm.status"
              placeholder="Select status"
              class="px-2"
              :options="statusOptions"
              :danger="!!!row.editForm.status"
            />
          </div>
          <div
            v-else
            class="capitalize"
          >
            {{ row.status.toLowerCase() }}
          </div>
        </template>
        <template #expected_month="{ row }">
          <div>
            {{ validateAndFormatDate(row.expected_month, 'MMM-YYYY') }}
          </div>
        </template>
        <template #company="{ row }">
          <div v-if="row.isEditing">
            <select-with-search
              hide-search
              v-model="row.editForm.company"
              placeholder="Select company"
              class="px-2"
              :options="options.company"
              :danger="!!!row.editForm.company"
            />
          </div>
          <div v-else>
            {{ row.company || '-' }}
          </div>
        </template>
        <template #destination="{ row }">
          <div v-if="row.isEditing">
            <vs-input
              :danger="!!!row.editForm.destination"
              :danger-text="'* Required'"
              v-model="row.editForm.destination"
              placeholder="Enter destination"
            />
          </div>
          <div v-else>
            {{ row.destination || '-' }}
          </div>
        </template>
        <template #estimate_time_arrival="{ row }">
          <div v-if="row.isEditing">
            <date-picker
              class="w-full"
              type="datetime"
              format="DD-MMM-YYYY HH:mm"
              v-model="row.editForm.estimate_time_arrival"
              :class="{ 'is-not-valid': !!!row.editForm.estimate_time_arrival }"
              :is-valid="!!row.editForm.estimate_time_arrival"
            />
          </div>
          <div v-else>
            {{ validateAndFormatDate(row.estimate_time_arrival, 'DD-MMM-YYYY HH:mm') }}
          </div>
        </template>
        <template #actual_time_arrival="{ row }">
          <div v-if="row.isEditing">
            <date-picker
              class="w-full"
              type="datetime"
              format="DD-MMM-YYYY HH:mm"
              v-model="row.editForm.actual_time_arrival"
            />
          </div>
          <div v-else>
            {{ validateAndFormatDate(row.actual_time_arrival, 'DD-MMM-YYYY HH:mm') }}
          </div>
        </template>
        <template #commence_loading="{ row }">
          <div v-if="row.isEditing">
            <date-picker
              class="w-full"
              type="datetime"
              format="DD-MMM-YYYY HH:mm"
              v-model="row.editForm.commence_loading"
            />
          </div>
          <div v-else>
            {{ validateAndFormatDate(row.commence_loading, 'DD-MMM-YYYY HH:mm') }}
          </div>
        </template>
        <template #complete_loading="{ row }">
          <div v-if="row.isEditing">
            <date-picker
              class="w-full"
              type="datetime"
              format="DD-MMM-YYYY HH:mm"
              v-model="row.editForm.complete_loading"
            />
          </div>
          <div v-else>
            {{ validateAndFormatDate(row.complete_loading, 'DD-MMM-YYYY HH:mm') }}
          </div>
        </template>
        <template #updated_at="{ row }">
          <span>{{ validateAndFormatDate(row.updated_at, 'DD-MMM-YYYY HH:mm') }}</span>
        </template>
        <template #last_sync_date="{ row }">
          <span>{{ validateAndFormatDate(row.last_sync_date, 'DD-MMM-YYYY HH:mm') }}</span>
        </template>
        <!-- Map Dynamic Product Data -->
        <template
          v-for="item in productKeyList"
          #[`${item.key}`]="{ row }"
        >
          <div
            v-if="row.isEditing"
            class="flex flex-row"
          >
            <v-autonumeric
              v-if="row[item.company] && row[item.company][item.key] > -1"
              v-model="row.editForm[item.company][item.key]"
              class="vs-input--input w-40"
              :class="{ 'is-not-valid': !row.editForm[item.company][item.key] }"
              :options="globalNumericOptions"
              @input="handleCalculateTonnage(row.editForm)"
            />
          </div>
          <div v-else>
            {{ row[item.company] && row[item.company][item.key] > -1 ? handleValidateAndFormatNumber(row[item.company][item.key]) : '' }}
          </div>
        </template>
        <template #total_tonnage="{ row }">
          <div
            v-if="row.isEditing"
            class="flex flex-row"
          >
            <v-autonumeric
              v-model="row.editForm.total_tonnage"
              class="vs-input--input w-40"
              :options="globalNumericOptions"
              disabled
            />
            <div class="px-5 flex flex-col justify-center rounded-r-lg bg-primary">
              <span class="text-white">mt</span>
            </div>
          </div>
          <div v-else>
            {{ handleValidateAndFormatNumber(row.total_tonnage) }}
          </div>
        </template>
        <template #stowage_plan="{ row }">
          <div
            v-if="row.isEditing"
            class="flex flex-row"
          >
            <v-autonumeric
              v-model="row.editForm.stowage_plan"
              class="vs-input--input w-40"
              :class="{ 'is-not-valid': !row.editForm.stowage_plan }"
              :options="globalNumericOptions"
            />
            <div class="px-5 flex flex-col justify-center rounded-r-lg bg-primary">
              <span class="text-white">mt</span>
            </div>
          </div>
          <div v-else>
            {{ handleValidateAndFormatNumber(row.stowage_plan) }}
          </div>
        </template>
        <template #actual_loaded="{ row }">
          <div
            v-if="row.isEditing"
            class="flex flex-row"
          >
            <v-autonumeric
              v-model="row.editForm.actual_loaded"
              class="vs-input--input w-40"
              :class="{ 'is-not-valid': !row.editForm.actual_loaded }"
              :options="globalNumericOptions"
            />
            <div class="px-5 flex flex-col justify-center rounded-r-lg bg-primary">
              <span class="text-white">mt</span>
            </div>
          </div>
          <div v-else>
            {{ handleValidateAndFormatNumber(row.actual_loaded) }}
          </div>
        </template>
        <template #demmurage="{ row }">
          <div
            v-if="row.isEditing"
            class="flex flex-row"
          >
            <v-autonumeric
              v-model="row.editForm.demmurage"
              class="vs-input--input w-40"
              :class="{ 'is-not-valid': !row.editForm.demmurage }"
              :options="globalNumericOptions"
            />
            <div class="px-5 flex flex-col justify-center rounded-r-lg bg-primary">
              <span class="text-white">mt</span>
            </div>
          </div>
          <div v-else>
            {{ handleValidateAndFormatNumber(row.demmurage) }}
          </div>
        </template>
        <template #loading_facility="{ row }">
          <div v-if="row.isEditing">
            <select-with-search
              hide-search
              v-model="row.editForm.loading_facility.id"
              placeholder="Select loading facility"
              class="px-2"
              :options="options.loading_facility"
            />
          </div>
          <div v-else>
            {{ !isEmpty(row.loading_facility) ? row.loading_facility.name : '-' }}
          </div>
        </template>
        <template #flf_fc_nominate="{ row }">
          <div v-if="row.isEditing">
            <select-with-search
              hide-search
              v-model="row.editForm.flf_fc_nominate.id"
              placeholder="Select flf fc nominate"
              class="px-2"
              :options="options.flf_fc_nominate"
            />
          </div>
          <div v-else>
            {{ !isEmpty(row.flf_fc_nominate) ? row.flf_fc_nominate.name : '-' }}
          </div>
        </template>
        <template #agency="{ row }">
          <div v-if="row.isEditing">
            <select-with-search
              v-model="row.editForm.agency.id"
              placeholder="Select agency"
              class="px-2"
              :options="options.agency"
            />
          </div>
          <div v-else>
            {{ !isEmpty(row.agency) ? row.agency.name : '-' }}
          </div>
        </template>
        <template #appoint="{ row }">
          <div v-if="row.isEditing">
            <date-picker
              class="w-full"
              type="datetime"
              format="DD-MMM-YYYY HH:mm"
              v-model="row.editForm.appoint"
            />
          </div>
          <div v-else>
            {{ validateAndFormatDate(row.appoint, 'DD-MMM-YYYY HH:mm') }}
          </div>
        </template>
        <template #swtd_plan="{ row }">
          <div v-if="row.isEditing">
            <date-picker
              class="w-full"
              type="datetime"
              format="DD-MMM-YYYY HH:mm"
              v-model="row.editForm.swtd_plan"
            />
          </div>
          <div v-else>
            {{ validateAndFormatDate(row.swtd_plan, 'DD-MMM-YYYY HH:mm') }}
          </div>
        </template>
        <template #dwt="{ row }">
          <div
            v-if="row.isEditing"
            class="flex flex-row"
          >
            <v-autonumeric
              v-model="row.editForm.dwt"
              class="vs-input--input w-40"
              :class="{ 'is-not-valid': !row.editForm.dwt }"
              :options="globalNumericOptions"
            />
            <div class="px-5 flex flex-col justify-center rounded-r-lg bg-primary">
              <span class="text-white">mt</span>
            </div>
          </div>
          <div v-else>
            {{ handleValidateAndFormatNumber(row.dwt) }}
          </div>
        </template>
        <template #vessel_type="{ row }">
          <div v-if="row.isEditing">
            <select-with-search
              hide-search
              v-model="row.editForm.vessel_type.id"
              placeholder="Select vessel type"
              class="px-2"
              :options="options.vessel_type"
            />
          </div>
          <div v-else>
            {{ !isEmpty(row.vessel_type) ? row.vessel_type.name : '-' }}
          </div>
        </template>
        <template #remark="{ row }">
          <div v-if="row.isEditing">
            <vs-input
              v-model="row.editForm.remark"
              placeholder="Enter remarks"
            />
          </div>
          <div v-else>
            {{ row.remark || '-' }}
          </div>
        </template>

        <!-- Expand freeze column -->
        <template #detail-frozen="{ parentData, parentIndex }">
          <template v-if="!loadingHistory && getHistoryDataById(parentData.id).length">
            <tr
              v-for="(item, cIdx) in getHistoryDataById(parentData.id)"
              :key="`freeze_${parentIndex}_${cIdx}`"
              class="container-tr-history"
            >
              <td />
              <td>
                <div class="flex items-center justify-end">
                  <img :src="require('@/assets/shipo-icon-arrow-forward.svg')">
                </div>
              </td>
              <td>{{ item.name_of_vessel || '-' }}</td>
              <td>{{ item.l_port || '-' }}</td>
              <td>{{ validateAndFormatDate(item.lay, 'DD-MMM-YYYY') }}</td>
              <td>{{ validateAndFormatDate(item.can, 'DD-MMM-YYYY') }}</td>
            </tr>
          </template>
          <template v-if="loadingHistory || !getHistoryDataById(parentData.id).length">
            <tr
              class="container-tr-history"
            >
              <td />
              <td>
                <div class="flex items-center justify-end">
                  <img :src="require('@/assets/shipo-icon-arrow-forward.svg')">
                </div>
              </td>
              <td>{{ loadingHistory ? 'Loading please wait' : 'No history found for this VLU' }}</td>
              <td />
              <td />
              <td />
            </tr>
          </template>
        </template>

        <!-- Expand scroll column -->
        <template #detail="{ parentData, parentIndex }">
          <template v-if="!loadingHistory && getHistoryDataById(parentData.id).length">
            <tr
              v-for="(item, cIdx) in getHistoryDataById(parentData.id)"
              :key="`freeze_${parentIndex}_${cIdx}`"
              class="container-tr-history"
            >
              <td>{{ item.end_user || '-' }}</td>
              <td>{{ item.status || '-' }}</td>
              <td>{{ validateAndFormatDate(item.expected_month, 'MMM-YYYY') }}</td>
              <td>{{ item.company || '-' }}</td>
              <td>{{ item.destination || '-' }}</td>
              <td>{{ validateAndFormatDate(item.estimate_time_arrival, 'DD-MMM-YYYY HH:mm') }}</td>
              <td>{{ validateAndFormatDate(item.actual_time_arrival, 'DD-MMM-YYYY HH:mm') }}</td>
              <td>{{ validateAndFormatDate(item.commence_loading, 'DD-MMM-YYYY HH:mm') }}</td>
              <td>{{ validateAndFormatDate(item.complete_loading, 'DD-MMM-YYYY HH:mm') }}</td>
              <td>{{ validateAndFormatDate(item.updated_at, 'DD-MMM-YYYY HH:mm') }}</td>
              <td>{{ validateAndFormatDate(item.last_sync_date, 'DD-MMM-YYYY HH:mm') }}</td>
              <td
                v-for="(product, i) in productKeyList"
                :key="`${product.key}-${i}`"
              >
                {{
                  item[product.company] && item[product.company][product.key] > -1
                    ? handleValidateAndFormatNumber(item[product.company][product.key])
                    : ''
                }}
              </td>
              <td>{{ handleValidateAndFormatNumber(item.total_tonnage) }}</td>
              <td>{{ handleValidateAndFormatNumber(item.stowage_plan) }}</td>
              <td>{{ handleValidateAndFormatNumber(item.actual_loaded) }}</td>
              <td>{{ handleValidateAndFormatNumber(item.demmurage) }}</td>
              <td>{{ !isEmpty(item.loading_facility) ? item.loading_facility.name : '-' }}</td>
              <td>{{ !isEmpty(item.flf_fc_nominate) ? item.flf_fc_nominate.name : '-' }}</td>
              <td>{{ !isEmpty(item.agency) ? item.agency.name : '-' }}</td>
              <td>{{ validateAndFormatDate(item.appoint, 'DD-MMM-YYYY HH:mm') }}</td>
              <td>{{ validateAndFormatDate(item.swtd_plan, 'DD-MMM-YYYY HH:mm') }}</td>
              <td>{{ handleValidateAndFormatNumber(item.dwt) }}</td>
              <td>{{ !isEmpty(item.vessel_type) ? item.vessel_type.name : '-' }}</td>
              <td>{{ item.remark || '-' }}</td>
            </tr>
          </template>
          <template v-if="loadingHistory || (!loadingHistory && !getHistoryDataById(parentData.id).length)">
            <tr
              class="container-tr-history"
            >
              <td v-for="_ in populateExpandScrollData()" />
            </tr>
          </template>
        </template>
      </data-table>
      <table-bottom
        class="mt-6"
        @fetch="fetchVesselLineUpList()"
      />
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'
import { mapGetters } from 'vuex'

import DataTable from '@/components/dataTable'
import DatePicker from '@/components/datePicker'
import SelectWithSearch from '@/components/selectWithSearch'
import TableBottom from '@/components/tableBottom'
import TableTop from '@/components/tableTop'
import { PAGE_TITLE } from '@/fixtures/Constants'
import { isNumber } from '@/utils/salesPlanUtils'

import downloadUtils from '../../../utils/downloadUtils'

export default {
  metaInfo: {
    title: `${PAGE_TITLE} List Vessel Line Up`
  },
  components: {
    DatePicker,
    SelectWithSearch,
    TableBottom,
    TableTop,
    DataTable
  },
  data() {
    return {
      isBusy: false,
      filter: {
        expected_month: null,
        vessel: null,
        company: null,
        l_port: null,
        status: null,
        sort_by: 'expected_month',
        sort_dir: 'desc'
      },
      options: {
        vessel: [],
        company: [],
        l_port: [],
        status: [
          { text: 'Incoming Vessel', value: 'Incoming Vessel' },
          { text: 'Complete', value: 'Complete' },
          { text: 'Waiting Load', value: 'Waiting Load' },
          { text: 'Loading', value: 'Loading' }
        ],
        loading_facility: [],
        flf_fc_nominate: [],
        agency: [],
        vessel_type: []
      },
      tableHeaders: [
        { key: 'no', label: 'No', width: '50px', freeze: true },
        { key: 'action', label: 'Action',freeze: true },
        { key: 'name_of_vessel', label: 'Name of Vessel', sortable: true, freeze: true },
        { key: 'l_port', label: 'POL', sortable: true, freeze: true },
        { key: 'lay', label: 'Lay', width: '170px', sortable: true, freeze: true },
        { key: 'can', label: 'Can', width: '170px', sortable: true, freeze: true },
        { key: 'end_user', label: 'End User', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'expected_month', label: 'Expected Month', width: '150px', sortable: true },
        { key: 'company', label: 'Company', sortable: true },
        { key: 'destination', label: 'Destination', sortable: true },
        { key: 'estimate_time_arrival', label: 'ETA', width: '230px', sortable: true },
        { key: 'actual_time_arrival', label: 'ATA', width: '230px', sortable: true },
        { key: 'commence_loading', label: 'Commence Loading', width: '230px', sortable: true },
        { key: 'complete_loading', label: 'Complete Loading', width: '230px', sortable: true },
        { key: 'updated_at', label: 'Update Date' },
        { key: 'last_sync_date', label: 'SOS Update Date' },
        { key: 'total_tonnage', label: 'Total Tonnage', sortable: true, group: 'Quantity Figure' },
        { key: 'stowage_plan', label: 'Stowage Plan', sortable: true, group: 'Quantity Figure' },
        { key: 'actual_loaded', label: 'Actual Loaded', sortable: true, group: 'Quantity Figure' },
        { key: 'demmurage', label: 'Demmurage', sortable: true, group: 'Quantity Figure' },
        { key: 'loading_facility', label: 'Loading Facilities', sortable: true, group: 'Loading Facilities' },
        { key: 'flf_fc_nominate', label: 'FLF/FC Nominate', sortable: true, group: 'Loading Facilities' },
        { key: 'agency', label: 'Agency', sortable: true, group: 'Agent Info' },
        { key: 'appoint', label: 'Appoint', width: '230px', sortable: true, group: 'Agent Info' },
        { key: 'swtd_plan', label: 'STWD Plan', width: '230px', sortable: true, group: 'Agent Info' },
        { key: 'dwt', label: 'DWT', sortable: true, group: 'Vessel Info' },
        { key: 'vessel_type', label: 'Type of Vessel', sortable: true, group: 'Vessel Info' },
        { key: 'remark', label: 'Remarks', sortable: true, group: 'Remarks' }
      ],
      groupHeader: [
        {
          title: 'Quantity Figure',
          startColumn: 'total_tonnage',
          endColumn: 'demmurage',
          backgroundColor: '#E0F7FA'
        },
        {
          title: 'Loading Facilities',
          startColumn: 'loading_facility',
          endColumn: 'flf_fc_nominate',
          backgroundColor: '#FFDDE1'
        },
        {
          title: 'Agent Info',
          startColumn: 'agency',
          endColumn: 'swtd_plan',
          backgroundColor: '#FFD1B3'
        },
        {
          title: 'Vessel Info',
          startColumn: 'dwt',
          endColumn: 'vessel_type',
          backgroundColor: '#F0E6F6'
        },
        {
          title: 'Remarks',
          startColumn: 'remark',
          endColumn: 'remark',
          backgroundColor: '#E6F3FF'
        }
      ],
      tableData: [],
      thirdPartyProductKey: [],
      immProductKey: [],
      bekProductKey: [],
      tcmProductKey: [],
      jbgProductKey: [],
      ktdProductKey: [],
      expandedRowsList: [],
      historyRowData: [],
      loadingHistory: false,
      isDownload: false,
      lastSyncTimeData: '-',
      isLoadingSync: false,
      isLoadingFLF: false,
      usedColors: new Set(),
      productKeyList: []
    }
  },
  mounted() {
    this.getVessel()
    this.getLPort()
    this.getStatuses()
    this.fetchVesselLineUpList()
    this.getAgencies()
    this.getLoadingFacilities()
    this.getFlfFcNominates()
    this.getVesselTypes()
    this.fetchCompanies()
  },
  computed: {
    ...mapGetters({
      vessel: 'VesselLineUp/vessel',
      polOptions: 'VesselLineUp/polOptions',
      statusOptions: 'VesselLineUp/statusOptions',
      vesselLineUpList: 'VesselLineUp/vesselLineUpList',
      currentPage: 'Table/currentPage',
      pageSize: 'Table/pageSize',
      agencies: 'AgencyManagement/agencies',
      loadingFacilities: 'VesselLineUp/loadingFacilities',
      flfFcNominates: 'VesselLineUp/flfFcNominates',
      vesselTypes: 'VesselLineUp/vesselTypes',
      exportFile: 'VesselLineUp/exportFile',
      exportTBSFile: 'VesselLineUp/exportTBSFile',
      lastSyncTime: 'VesselLineUp/lastSyncTime',
      companies: 'Companies/companies'
    }),
    permission() {
      return { page: this.$route.meta.permission.page, name: this.$route.meta.permission.name }
    }
  },
  watch: {
    vessel: {
      immediate: true,
      handler(val) {
        if (!this.isEmpty(val)) {
          this.options.vessel = val
        }
      }
    },
    vesselLineUpList: {
      immediate: true,
      handler(val) {
        if (!this.isEmpty(val)) {
          // set tableHeaders & groupHeader to default data
          this.expandedRowsList = this.$options.data().expandedRowsList;
          this.historyRowData = this.$options.data().historyRowData;

          this.tableHeaders = this.$options.data().tableHeaders;
          this.groupHeader = this.$options.data().groupHeader;

          this.populateDataTable(val)
        } else {
          this.tableData = []
        }
      }
    },
    agencies: {
      immediate: true,
      handler(val) {
        if (!this.isEmpty(val)) {
          this.options.agency = val.map(v => ({ text: v.name, value: v.id }))
        }
      }
    },
    loadingFacilities: {
      immediate: true,
      handler(val) {
        if (!this.isEmpty(val)) {
          this.options.loading_facility = val
        }
      }
    },
    flfFcNominates: {
      immediate: true,
      handler(val) {
        if (!this.isEmpty(val)) {
          this.options.flf_fc_nominate = val
        }
      }
    },
    vesselTypes: {
      immediate: true,
      handler(val) {
        if (!this.isEmpty(val)) {
          this.options.vessel_type = val
        }
      }
    },
    exportFile: {
      handler(val) {
        if (!this.isEmpty(val)) {
          downloadUtils(
            val,
            `Vessel Line Up (VLU) ${this.filter.expected_month ? this.filter.expected_month : this.moment().year()}.xlsx`
          )
          // // Reset the export file state
          this.$store.dispatch('VesselLineUp/resetExportFiles');
        }
      }
    },
    exportTBSFile: {
      handler(val) {
        if (!this.isEmpty(val)) {
          downloadUtils(
            val,
            `TBS ${this.filter.expected_month}.xlsx`
          )
          // // Reset the export file state
          this.$store.dispatch('VesselLineUp/resetExportTBSFiles');
        }
      }
    },
    filter: {
      handler(newVal) {
        this.fetchVesselLineUpList();
      },
      deep: true
    },
    lastSyncTime: {
      immediate: true,
      handler(val) {
        if (!this.isEmpty(val)) {
          this.lastSyncTimeData = val
        }

        this.isLoadingSync = false
      }
    },
    isLoadingSync: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.$vs.loading({
              color: 'secondary',
              container: '#sync-loading',
              scale: 0.35
            })
          })
        } else {
          this.$vs.loading.close('#sync-loading > .con-vs-loading')
        }
      }
    },
    companies: {
      handler(val) {
        if (val) {
          this.options.company = val.map(item => ({
            value: item.code,
            text: item.code,
            id: item.id
          }))
        }
      }
    }
  },
  methods: {
    async fetchCompanies() {
      try {
        await this.$store.dispatch('Companies/fetchAllCompanies', {
          is_master_data: true,
          type: 'SITE_OWNER',
          status: true,
          sort_dir: 'asc',
          sort_by: 'name'
        })
      } catch (e) {
        this.showFailedNotification(this, 'Failed to fetch companies, please try again')
      }
    },
    handleCalculateTonnage(form) {
      let total = 0
      Object.entries(form).forEach(([key, value]) => {
        const keyToCalculate = this.productKeyList.map(v => v.key)
        if (keyToCalculate.includes(key)) {
          Object.entries(value).forEach(([_, cValue]) => {
            const tempValue = Number(cValue)
            if (isNumber(tempValue))
              total += tempValue
          });
        }
      })

      form.total_tonnage = total.toFixed(2)
    },
    getHistoryDataById(id) {
      const data = this.historyRowData.find(v => v.id === id)
      return !isEmpty(data) ? data.history : []
    },
    async getVesselLineUpHistories(id) {
      try {
        const data = await this.$store.dispatch('VesselLineUp/getVesselLineUpHistories', id)

        const existHistory = this.historyRowData.findIndex(v => v.id === id)
        if (!isEmpty(data)) {
          if (existHistory > -1) {
            this.historyRowData.splice(existHistory, 1, {
              id: id,
              history: data
            })
          } else {
            this.historyRowData.push({
              id: id,
              history: data
            })
          }
        }
        
        this.loadingHistory = false
      } catch (e) {
        this.loadingHistory = false
        this.showFailedNotification(this, 'Failed to fetch VLU History, please try again')
      }
    },
    populateExpandScrollData() {
      const scrollData = _.cloneDeep(this.tableHeaders)
      return scrollData.splice(5, scrollData.length-6)
    },
    populateDataTable(val) {
      if (this.isEmpty(val)) return

      this.tableData = this.cloneDeep(val)

      const tempProductData = this.cloneDeep(val).map(v => ({
        ...this.groupByCompany(v.vlu_tonnage_per_products)
      }))

      const mergedProductData = tempProductData.reduce((acc, obj) => {
        Object.keys(obj).forEach(key => {
          acc[key] = {
            ...(acc[key] || {}),
            ...obj[key]
          }
        })
        return acc
      }, {})

      const newGroupHeader = Object.entries(mergedProductData).map(([company, items]) => {
        const keys = Object.keys(items)
        return {
          title: company === 'third_party' ? '3RD Party' : company.toUpperCase(),
          startColumn: keys[0],
          endColumn: keys[keys.length - 1],
          backgroundColor: this.getRandomColor()
        }
      })

      this.groupHeader.splice(0, 0, ...newGroupHeader)

      this.productKeyList = Object.entries(mergedProductData).flatMap(([company, items]) =>
        Object.entries(items).map(([key, value]) => ({
          key,
          label: value.title,
          company
        }))
      )

      this.tableHeaders.splice(
        17,
        0,
        ...this.productKeyList.map(v => ({
          ...v,
          sortable: false
        }))
      )
    },
    groupByCompany(data) {
      const grouped = {};

      data.forEach(v => {
        const normalizedKey = v.product_id.toLowerCase()
        const normalizeKeyCompany = v.type.toLowerCase() === 'third_party' ? 'third_party' : v.company_code.toLowerCase()
        if (!grouped[normalizeKeyCompany]) {
          grouped[normalizeKeyCompany] = {};
        }
        grouped[normalizeKeyCompany][normalizedKey] = {
          title: v.product_id
        }
      })

      return grouped;
    },
    getRandomColor(alpha = 1) {
      let color;
      do {
        const r = Math.floor(Math.random() * 156) + 100;
        const g = Math.floor(Math.random() * 156) + 100;
        const b = Math.floor(Math.random() * 156) + 100;
        color = `rgba(${r},${g},${b},${alpha})`;
      } while (this.usedColors.has(color));

      this.usedColors.add(color);
      return color;
    },
    async getAgencies() {
      await this.$store.dispatch('AgencyManagement/fetchAgencies', {
        is_master_data: false,
        status: true,
        sort_dir: 'asc',
        sort_by: 'name'
      })
    },
    async getLoadingFacilities() {
      await this.$store.dispatch('VesselLineUp/getLoadingFacilities')
    },
    async getFlfFcNominates() {
      await this.$store.dispatch('VesselLineUp/getFlfFcNominates')
    },
    async getVesselTypes() {
      await this.$store.dispatch('VesselLineUp/getVesselTypes')
    },
    async getVessel() {
      await this.$store.dispatch('VesselLineUp/getVessel')
    },
    async getLPort() {
      await this.$store.dispatch('VesselLineUp/getVLUPolOptions')
    },
    async getStatuses() {
      await this.$store.dispatch('VesselLineUp/getVLUStatusOptions')
    },
    async fetchVesselLineUpList() {
      try {
        this.isBusy = true
        await this.$store.dispatch('VesselLineUp/getVesselLineUpList', {
          ...this.filter,
          expected_month: this.filter.expected_month,
          sort_by: this.filter.sort_by || 'expected_month',
          sort_dir: this.filter.sort_dir || 'desc'
        })
        this.isBusy = false
      } catch (e) {
        this.isBusy = false
        this.showFailedNotification(this, 'Failed to fetch VLU list, please try again')
      }
    },
    sort(sortBy, sortDir) {
      this.filter.sort_by = sortBy
      this.filter.sort_dir = sortDir

      this.fetchVesselLineUpList()
    },
    validateAndFormatDate(date, format) {
      // every falsy data transformed into '-'
      if (date && date !== '-') {
        return this.moment(date, ['DD-DD/M', 'YYYY-MM-DDTHH:mm.SSSSZ']).format(format)
      }
      return '-'
    },
    toggleRow(tr) {
      const index = this.expandedRowsList.indexOf(tr.id);
      if (index > -1) {
        this.loadingHistory = false
        tr.isExpand = false
        this.expandedRowsList.splice(index, 1); // Collapse
      } else {
        this.loadingHistory = true
        tr.isExpand = true
        this.expandedRowsList.push(tr.id); // Expand
        this.getVesselLineUpHistories(tr.id)
      }
    },
    onHandleEdit(row) {
      // Cancel any existing edit or add
      if (this.tableData.some(r => r.isEditing)) {
        this.showFailedNotification(this, 'Only one action can be active at a time. Please save your changes first', 'Error')
        return
      }

      // Populate Edit Form
      const index = this.tableData.findIndex(item => item.id === row.id)
      const { editForm, ...dataRow } = row
      if (index !== -1) {
        this.$set(this.tableData[index], 'isEditing', true)
        this.$set(this.tableData[index], 'editForm', {
          ...dataRow,
          swtd_plan: row.swtd_plan ? this.moment(row.swtd_plan).toDate() : null,
          appoint: row.appoint ? this.moment(row.appoint).toDate() : null,
          lay: row.lay ? this.moment(row.lay).toDate() : '',
          can: row.can ? this.moment(row.can).toDate() : '',
          estimate_time_arrival: row.estimate_time_arrival ? this.moment(row.estimate_time_arrival).toDate() : '',
          actual_time_arrival: row.actual_time_arrival ? this.moment(row.actual_time_arrival).toDate() : '',
          commence_loading: row.commence_loading ? this.moment(row.commence_loading).toDate() : '',
          complete_loading: row.complete_loading ? this.moment(row.complete_loading).toDate() : '',
          loading_facility: row.loading_facility ?? { name: '', id: null },
          flf_fc_nominate: row.flf_fc_nominate ?? { name: '', id: null },
          agency: row.agency ?? { name: '', id: null },
          vessel_type: row.vessel_type ?? { name: '', id: null }
        })
      }
    },
    onHandleCancel(row) {
      // Just cancel the edit
      const index = this.tableData.findIndex(item => item.id === row.id)
      if (index !== -1) {
        this.tableData[index].isEditing = false
        this.$set(this.tableData[index], 'isEditing', false)
      }
    },
    async onHandleSubmit(row) {
      // Handle edit
      // Populate data edit
      const {
        id,
        updated_at,
        agency,
        generated_blu,
        loading_facility,
        flf_fc_nominate,
        vessel_type,
        isEditing,
        sos_detail_id,
        isExpand,
        ...data
      } = row.editForm

      const formData = {
        ...data,
        agency_id: agency.id ?? null,
        loading_facility_id: loading_facility.id ?? null,
        vessel_type_id: vessel_type.id ?? null,
        flf_fc_nominate_id: flf_fc_nominate.id ?? null,
        reason: null,
        estimate_time_arrival: data.estimate_time_arrival ?? null
      }

      const dataNeedToValidate = [
        'end_user',
        'lay',
        'can',
        'name_of_vessel',
        'l_port',
        'company',
        'destination',
        'estimate_time_arrival',
        'status'
      ]

      // Validate fields
      const validate = Object.keys(row.editForm)
        .find(key => dataNeedToValidate.includes(key) && (row.editForm[key] === '' || row.editForm[key] === null))

      if (validate) {
        this.showFailedNotification(this, `VLU ${validate.replaceAll('_', ' ')} cannot be empty`, 'Error')
        return
      }

      try {
        await this.$store.dispatch('VesselLineUp/submitVesselLineUp', {
          id: id,
          form: formData,
          isCreate: false
        })

        this.showSuccessNotification(this, 'VLU successfully updated.')
        this.fetchVesselLineUpList()
      } catch ({ error }) {
        const message = error?.errors?.[0]?.[0]?.message || error?.message || 'Failed to save changes, please try again'

        this.showFailedNotification(this, message, 'Error')
      }
    },
    async downloadVLU() {
      this.isDownload = true;
      try {
        this.isBusy = true
        await this.$store.dispatch('VesselLineUp/downloadExport', {
          ...this.filter,
          sort_by: this.filter.sort_by || 'expected_month',
          sort_dir: this.filter.sort_dir || 'desc'
        }, {
          headers: {
            accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          },
          responseType: 'blob'
        });
        this.isDownload = false;
        this.isBusy = false;
      } catch (error) {
        this.isDownload = false;
        this.isBusy = false;
        this.showFailedNotification(this, 'Failed to download VLU, please try again');
      }
    },
    async downloadTBS() {
      this.isDownload = true;
      try {
        this.isBusy = true
        await this.$store.dispatch('VesselLineUp/downloadExportTBS', {
          expected_month: this.filter.expected_month
        }, {
          headers: {
            accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          },
          responseType: 'blob'
        });
        this.isDownload = false;
        this.isBusy = false;
      } catch (error) {
        this.isDownload = false;
        this.isBusy = false;
        this.showFailedNotification(this, 'Failed to download TBS, please try again');
      }
    },
    resetFilter() {
      this.filter = this.$options.data().filter
      this.$refs.tabletop.$emit('reset-search')
      this.fetchVesselLineUpList()
    },
    async onHandleVLUSync() {
      this.isLoadingSync = true
      try {
        await this.$store.dispatch('VesselLineUp/postVLUSync')

        this.showSuccessNotification(this, 'VLU successfully sync.')
      } catch ({ data }) {
        this.isLoadingSync = false
        const message = data?.error?.message || 'Failed to save changes, please try again'

        this.showFailedNotification(this, message, 'Error')
      }
    },
    async sendToFLF() {
      this.isLoadingFLF = true
      try {
        await this.$store.dispatch('VesselLineUp/postVLUSendToFLF')

        this.showSuccessNotification(this, 'VLU successfully send to FLF/FC.')
      } catch ({ data }) {
        const message = data?.error?.message || 'Failed to save changes, please try again'
        if(message.includes('No available TBS to send.')) {
          this.showWarningNotification(this, message)
        } else {
          this.showFailedNotification(this, message, 'Error')
        }

      } finally {
        this.isLoadingFLF = false
      }
    },
    getPolOptions(row) {
      const options = [...this.polOptions];
      if(!options.find(opt => opt.value === row.l_port)) {
        options.push({ text: row.l_port, value: row.l_port})
      }
      return options
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  @apply py-4;
  @apply rounded-lg;
  @apply border-2;
  @apply font-semibold;
  @apply min-w-button;
  @apply text-base;
  height: calc(1rem * 10 / 3);

  &.shadow-primary {
    -webkit-box-shadow: 0 8px 25px -8px rgba(var(--vs-primary), 1);
    box-shadow: 0 8px 25px -8px rgba(var(--vs-primary), 1);
  }

  &.shadow-secondary {
    -webkit-box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary), 1);
    box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary), 1);
  }

  &:focus {
    @apply outline-none;
  }
}

.divider {
  border: 1px solid #CDC6E1;
  width: 1px;
}

.icon-transparent-bg {
  @apply cursor-pointer;
  @apply min-w-8;
  @apply h-8;
  background-color: #493493;
  border-radius: 0.5rem;

  &.action-submit {
    background-color: #D1F9E3
  }

  &.action-cancel {
    background-color: #FFD9D9
  }
}

.action-button {
  @apply py-0;
  @apply px-2;
  @apply ml-1;
  @apply h-8;
  -webkit-box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary), 1);
  box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary), 1);

  &:focus {
    @apply outline-none;
  }
}

.button-l-plan {
  @apply flex;
  @apply flex-row;
  @apply whitespace-no-wrap;
  @apply icon-transparent-bg;
  @apply items-center;
  @apply justify-items-auto;
  @apply text-white;
  padding: 0.15rem 0.25rem 0.15rem 0.15rem;

  span {
    @apply ml-1;
  }

  &.disabled {
    @apply text-grey-001;
    @apply cursor-not-allowed;
    background-color: rgba(222, 222, 222, 0.36);

    img {
      filter: grayscale(100%) brightness(110%);
    }
  }
}

.complete {
  @apply text-success;
  @apply bg-success-accent;
}

.loading {
  @apply text-danger;
  @apply bg-danger-accent;
}

.incoming-vessel {
  @apply text-primary;
  background-color: #F1F1FD;
}

.waiting-load {
  @apply text-secondary;
  background-color: #fef2ee;
}

/deep/ .vs-table--td {
  > span > span {
    @apply flex;
    @apply flex-wrap;
    @apply items-center;

    > div {
      @apply items-center;
    }
  }
}

.filter-container {
  @apply p-5 mt-5 flex flex-row items-center bg-white rounded-lg;
}

.filter-grey-img {
  filter: grayscale(100%) brightness(70%);
}

.container-tr-history {
  background-color: #F5F0FE !important;
  height: 30px !important;
  box-shadow: 0 0.2rem #F5F0FE;
}

</style>
